import { BaseDto } from './base-dto';
export class ListaCompraDto extends BaseDto {
    public articulo!: string;
    public comprado!: boolean;
}
